module.exports = __webpack_public_path__ + "static/media/63.9e6ce461.png";